import React, {
  useEffect,
  useCallback,
  useMemo,
  useContext
} from 'react';

import {
  Button
} from 'reactstrap';


// Start DragAndDrop
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import update from "immutability-helper";
// End DragAndDrop

import DocumentSignerConfigContext from './../document/context/signer_config_context';

import SignerForm from './form';

const SignerFormList = React.memo((props) => {
  const {
    formName,
    setResource,
    signerGroupIndex,
    signerGroup,
    signersCount,
    signersErrors = []
  } = props;

  let signers = _.map(props?.signers, (signer, index) => {
    if (!signer.custom_id) {
      signer.custom_id = _.uniqueId('signer-')
    }

    return signer;
  })

  const {
    resource
  } = useContext(DocumentSignerConfigContext);

  const setOrderSigner = useCallback((signers) => {
    let order = 0;
    _.each(signers, function(signer){
      if(signer?._destroy){
        signer.order = 0;
      } else {
        signer.order = order;
        order += 1;
      }
    })

    return signers;
  }, [])

  useEffect(() => {
    if(signers.length == 0){
      handleAddNewSigner()
    }
  }, []);

  const handleSigner = useCallback((signer, index) => {
    setResource(prevState => {
      let __signers = signerGroup ? [...signerGroup.signers] : [ ... prevState.signers ]
      __signers[index] = signer

      let hasAdvance = _.some(__signers, { signature_mode: "advance" });
      if (hasAdvance) {
        prevState.require_signers_order = true;
        prevState.certification_mode = "per_signer_certification"
      } else {
        prevState.certification_mode = prevState?.document_information?.has_signatures ? "per_signer_certification" : "single_certification"
      }

      if(signer.employee_sign){
        __signers = _.map(__signers, (_s, _i) => {
          if(_s.employee_sign && _i != index){
            _s["employee_sign"] = false
            _s["name"] = null;
            _s["role"] = null;
            _s["email"] = null;

            return { ... _s }
          } else {
            return _s
          }
        })
      }

      __signers = setOrderSigner(__signers);

      if(signerGroup){
        let _signerGroup = {... signerGroup}
        let _signerGroups = [...prevState.signer_groups]

        _signerGroup.signers = __signers
        _signerGroups[signerGroupIndex] = _signerGroup

        return { ... prevState, signer_groups: _signerGroups }
      }else{
        return { ...prevState, signers: __signers};
      }
    })
  }, [resource, signerGroup])

  const handleAddNewSigner = () => {
    let signerAttributes = {
      id: "",
      email: "",
      company_email: "",
      role: "",
      order: signersCount,
      _destroy: false,
      employee_sign: false,
      company_sign: false,
      custom_field_id: "",
      email_notification_sign: false,
      member_sign: false,
      signature_mode: "simple",
      hide_signature_image: false
    }

    setResource(prevState => {
      // Add new signer for SignerGroup
      if(signerGroup){
        let _signerGroup = { ... signerGroup }
        let _signerGroups = [...prevState.signer_groups]

        _signerGroup.signers = [... _signerGroup.signers, signerAttributes]
        _signerGroups[signerGroupIndex] = _signerGroup

        return { ... prevState, signer_groups: _signerGroups }
      }else{
        if(_.isUndefined(prevState.signers)){
          prevState.signers = []
        }

        return { ... prevState, signers: [...prevState.signers, signerAttributes] }
      }
    })
  }

  // Start DndProvider
  const handleMoveSigner = useCallback((dragIndex, hoverIndex) => {
    setResource(prevState => {
      // De esta forma se obtiene los firmantes mas actualizados ya que por props del signerGroup todavia no se refresca
      let _signers = signerGroup ? [ ... prevState.signer_groups[signerGroupIndex].signers ] : [ ... prevState.signers ];

      const dragSigner = _signers[dragIndex];
      _signers = update(_signers, {
        $splice: [
          [dragIndex, 1],
          [hoverIndex, 0, dragSigner],
        ],
      });

      _signers = setOrderSigner(_signers)

      if(signerGroup){
        let _signerGroup = { ... prevState.signer_groups[signerGroupIndex] }
        let _signerGroups = [...prevState.signer_groups]

        _signerGroup.signers= _signers
        _signerGroups[signerGroupIndex] = _signerGroup

        return { ... prevState, signer_groups: _signerGroups }

      }else{
        return { ...prevState, signers: _signers }
      }
    })
  }, []);
  // End DndProvider


  const signerErrorsAlert = useMemo(() => {
    if (signersErrors.length > 0) {
      return (
        <div className="row">
          <div className="col-12">
            {function () {
              return _.map(signersErrors, (error) => {
                return (
                  <div className="alert alert-danger text-center" key={_.uniqueId('SignerError-')}>
                    <i className="fas fa-exclamation-triangle mr-2" aria-hidden="true" title="Error"></i>
                    <span>{error}</span>
                  </div>
                )
              })
            }()}
          </div>
        </div>
      )
    }
  }, [signersErrors])

  const availableSigners = useMemo(() => {
    return _.filter(signers, (signer) => {
      return !signer._destroy
    })
  }, [signers])


  const drawSigners = () => {
    if (availableSigners.length > 0) {
      return(
        <div className="row">
          <div className="col-12">
            <DndProvider backend={HTML5Backend}>
              { _.map(signers, function(signer, index){
                return(
                  <SignerForm
                    key={ `signerForm-${ index }` }
                    signer={ signer }
                    callbackSetSigner={ handleSigner }
                    index={ index }
                    signerGroup={ signerGroup }
                    handleMoveSigner={ handleMoveSigner }
                    formName={ `${ formName }[${ index }]`}
                  />
                )
              })}
            </DndProvider>
          </div>
        </div>
      )
    } else {
      return(
        <div className="alert alert-primary text-center">
          <i className="fas fa-info-circle mr-2" aria-hidden="true" title="Información"></i>
          <span>Aún no has agregado firmantes</span>
        </div>
      )
    }
  }

  return(
    <div className="row">

      <div className="col-12">
        {signerErrorsAlert}

        { drawSigners() }
      </div>

      <div className="col-12">
        <Button
          outline
          color="success"
          size="sm"
          onClick={ e => handleAddNewSigner() }
          disabled={ resource.isPersisted }
        >
          <i className="fas fa-user-plus"></i>
          &nbsp;
          { I18n.t("signers.form.add_signer") }
        </Button>
      </div>
    </div>
  )
});

export default SignerFormList
